<template>
  <w-icon-wrapper icon-name='work-smaller-than-icon'>
    <g
      id='Gruppe_25444'
      data-name='Gruppe 25444'
      transform='translate(2.818 4)'
    >
      <path
        id='Pfad_55770'
        d='M20.272,20a1,1,0,0,0,.424-1.906L7.637,12,20.7,5.906a1,1,0,0,0-.846-1.812L2.909,12,19.85,19.906A.992.992,0,0,0,20.272,20Z'
        data-name='Pfad 55770'
        fill='currentColor'
        transform='translate(-2.909 -4.001)'
      />
    </g>
    <rect
      id='Rechteck_4029'
      data-name='Rechteck 4029'
      fill='none'
      height='24'
      width='24'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconSmallerThan' };
</script>
